/** 权限判断与获取 */
const getAuth = async () => {
  let auth = false;
  if (typeof Notification === 'undefined') {
    console.log('浏览器不支持 Notification API');
    auth = false;
    return;
  }
  if (Notification.permission === 'denied') {
    console.log('Notification 权限已被禁止');
    auth = false;
    return;
  }
  if (Notification.permission === 'granted') {
    console.log('Notification 可用');
    auth = true;
  } else {
    try {
      await Notification?.requestPermission()?.then(function (permission) {
        switch (permission) {
          case 'granted':
            console.log('Notification 可用');
            window.Tea('wap_notify_accept');
            auth = true;
            break;
          case 'denied':
            window.Tea('wap_notify_deny');
            console.log('Notification 权限已被禁止');
            auth = false;
            break;
          default:
            auth = false;
            console.log('Notification 权限尚未授权');
        }
      });
    } catch (err) {
      console.log(err, 'plugin mobile notification requestPermission error');
      auth = false;
    }
  }
  return auth;
};

type Options = {
  // 消息内容
  body: string;
  icon?: string;
  /** 在用户点击或关闭通知前，是否通知应该保持活动状态，而不是自动关闭 */
  requireInteraction: boolean;
  image: string;
  data: {
    time: string;
    url: string;
  };
};
export const sendNotification = async (title: string, options: Options) => {
  const auth = await getAuth();
  if (auth) {
    navigator.serviceWorker.ready.then((registration) => {
      if (registration?.showNotification) {
        registration?.showNotification(title, options);
        /** 埋点通知成功 */
        window.Tea('wap_notify_success');
        /** 每一次只发一次 */
        sessionStorage.setItem('is_notification', 'true');
      }
    });
  }
};
